import { Alert, Stack } from "@mui/material";
import { FormAccordionSection } from "Components/Shared/FormAccordionSection";
import { Resources, useResource } from "Translations/Resources";
import {
  PhotoInput,
  type PhotoState,
} from "Components/Shared/Merchant/Facilities/Sections/PhotoInput";
import { FACILITY_PHOTO_MAX_SIZE_MB } from "Components/Shared/Merchant/Facilities/constants";

const RESOURCES = Resources.Components.Merchant.Facilities.Form;

export type PhotoSlot = "outside" | "inside";

type Props = {
  isExpanded: boolean;
  onToggle: () => void;
  hasErrors?: boolean;
  isComplete?: boolean;
  photoOutside: PhotoState;
  photoInside: PhotoState;
  onPhotoChange: (slot: PhotoSlot, file: File | null) => void;
  onPhotoError: (slot: PhotoSlot, resource: string | null) => void;
  onDeletePhoto?: (slot: PhotoSlot) => void;
};

export const PhotoSection = ({
  isExpanded,
  onToggle,
  hasErrors,
  isComplete,
  photoOutside,
  photoInside,
  onPhotoChange,
  onPhotoError,
  onDeletePhoto,
}: Props) => {
  const { t } = useResource();

  return (
    <FormAccordionSection
      legend={t(RESOURCES.Legend.Photos)}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isComplete={isComplete}
      hasErrors={hasErrors}
    >
      <Stack gap={2}>
        <Alert severity="info">
          {t(RESOURCES.PhotosDescription, {
            maxSizeMb: FACILITY_PHOTO_MAX_SIZE_MB,
          })}
        </Alert>

        <Stack gap={3}>
          <PhotoInput
            label={t(RESOURCES.Fields.PhotoOutside)}
            photo={photoOutside}
            onChange={(file) => onPhotoChange("outside", file)}
            onError={(resource) => onPhotoError("outside", resource)}
            onDelete={
              onDeletePhoto ? () => onDeletePhoto("outside") : undefined
            }
          />
          <PhotoInput
            label={t(RESOURCES.Fields.PhotoInside)}
            photo={photoInside}
            onChange={(file) => onPhotoChange("inside", file)}
            onError={(resource) => onPhotoError("inside", resource)}
            onDelete={onDeletePhoto ? () => onDeletePhoto("inside") : undefined}
          />
        </Stack>
      </Stack>
    </FormAccordionSection>
  );
};
